import { useCustomT } from '@crimeos-frontend/shared/common'

import { handleAPIError } from '../../../utils/APIUtils'

import { GetFileUploaderFieldSignedReadUrlQuery as Query } from './query.generatedTypes'

interface UseAPIResponseHandlerReturnType {
  handleAPIResponse: (
    response: Query,
    onSuccess: (signedReadUrl: string) => void,
    onFailure?: (message: string) => void
  ) => void
}

const useAPIResponseHandler = (): UseAPIResponseHandlerReturnType => {
  const commonAPIErrorT = useCustomT('common:apiErrorMessages')
  const recordsCommonAPIErrorT = useCustomT('recordsCommon:apiErrorMessages')

  const handleAPIResponse = (
    response: Query,
    onSuccess: (signedReadUrl: string) => void,
    onFailure?: (message: string) => void
  ): void => {
    const hasEmptyResponse =
      !response || !response.getFileUploaderFieldSignedReadUrl

    if (hasEmptyResponse) throw new Error('FileUploaderSignedReadUrl not found')

    const fileUploaderSignedReadUrlResult =
      response.getFileUploaderFieldSignedReadUrl

    switch (fileUploaderSignedReadUrlResult.__typename) {
      case 'FileUploaderFieldSignedReadUrl': {
        onSuccess(fileUploaderSignedReadUrlResult.signedReadUrl)
        break
      }

      case 'RecordNotFound':
      case 'RecordAccessDenied': {
        const errorMessage =
          fileUploaderSignedReadUrlResult.message ||
          recordsCommonAPIErrorT(fileUploaderSignedReadUrlResult.__typename)

        handleAPIError(errorMessage, onFailure)
        break
      }

      case 'InvalidFileUrl': {
        const errorMessage =
          fileUploaderSignedReadUrlResult.message ||
          commonAPIErrorT('somethingWentWrong')

        handleAPIError(errorMessage, onFailure)
        break
      }
      case 'FieldIsDeleted':
      case 'FieldNotFound': {
        const errorMessage =
          fileUploaderSignedReadUrlResult.message ||
          recordsCommonAPIErrorT('configurationIsUpdated')

        handleAPIError(errorMessage, onFailure)
        break
      }
      case 'NotFileUploaderField': {
        const errorMessage =
          fileUploaderSignedReadUrlResult.message ||
          recordsCommonAPIErrorT('notFileUploaderField')

        handleAPIError(errorMessage, onFailure)
        break
      }

      default:
        throw new Error(
          `__typename: Invalid FileUploaderSignedReadUrl Response type`
        )
    }
  }

  return { handleAPIResponse }
}

export default useAPIResponseHandler
